module.exports = __webpack_public_path__ + "assets/img/barrrrrry.4e913928.png";